
const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
             "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]


export default {
  name: "es",
  Now: "Ahora",
  "X-Scale": "X",
  "Y-Scale": "Y",
  "Task list width": "Tamaño Lista de Tareas",
  "Before/After": "Expandir",
  "Display task list": "Lista de Tareas",

  'weekStart': 1,
  "weekdays": ["D", "L", "Ma", "Mi", "Ju", "Vi", "Sá"],
  months,
  monthsShort: months,
  'relativeTime': {
    'future': 'futuro',
    'past': 'pasado',
    's': 'segundos',
    'm': 'un minuto',
    'mm': '%d minutos',
    'h': 'una hora',
    'hh': '%d horas',
    'd': 'un día',
    'dd': '%d días',
    'M': 'un mes',
    'MM': '%d meses',
    'y': 'un año',
    'yy': '%d años'
  },
  'ordinal': (n) => {
    const o = n === 1 ? 'er' : ''
    return `${n}${o}`
  }
}



// WEBPACK FOOTER //
// ./src/pages/WorkPlan/WeeklyExecution/locale.js